// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2Sq48","sidebar":"Main_sidebar__2OV3J","stopwatch":"Main_stopwatch__36Hpg"};